let update_menuTags = function() {
    this.$store.dispatch("ModApps/jobs/update_menuTags");
};
export default update_menuTags;
